

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface StateParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface StateMst {
    id?: number;
    name: string;
    countryId: any;
  parameters?: StateParameter[];
  code?:any
  links?: any;
}

export abstract class StateData {
  //abstract fireRequest(data: StateMst, method: string): Observable<any>;
  abstract list(): Observable<StateMst[]>;
  abstract create(url: string,data: StateMst): Observable<any>;
  abstract update(url: string,data: StateMst): Observable<any>;
  abstract delete(url: string): Observable<any>;
}